import { NextSeo } from 'next-seo';
import React, { useEffect, useRef, useState } from 'react';
import useSWR from 'swr';
import { getSeoVisibility } from '../../../src/appconfig';
import ArticleProductCard from '../../../src/components/ArticlePage/ArticalProductCard/ArticleProductCard';
import { ArticleGridSection } from '../../../src/components/ArticlePage/ArticleImage/styled';
import { ProductsMayLikeSection } from '../../../src/components/ArticlePage/RelatedArticlesNew/styled';
import RelatedQuestionNew from '../../../src/components/ArticlePage/RelatedQuestionNew';
import { HomeWrapper } from '../../../src/components/HomePage/HomeBanner/styled';
import NewFooter from '../../../src/components/HomePage/NewFooter';
import NewHeader from '../../../src/components/HomePage/NewHeader';
import { SnackBar } from '../../../src/components/Product/PdpHeader/styled';
import { StickySection } from '../../../src/components/QnaPage/AskNowSection/styled';
import { QuestionContainer } from '../../../src/components/QnaPage/ColumnSix/styled';
import InstallNudge from '../../../src/components/QnaPage/InstallNudge/InstallNudge';
import PostedIn from '../../../src/components/QnaPage/PostedInSection/PostedIn';
import QuestionsHead from '../../../src/components/QnaPage/QuestionsHead';
import QuestionWrapper from '../../../src/components/QnaPage/QuestionWrapper';
import RelatedTopics from '../../../src/components/QnaPage/RelatedTopics';
import Breadcrumbs from '../../../src/components/StoreCategoryPage/Breadcrumbs';
import { googlePlayStoreLink } from '../../../src/Constants/branchUrls';
import { articleDetailFetcher } from '../../../src/datafetchers/ArticlePage';
import GlobalStyle from '../../../src/styles/globalStylesV2';
//import { firebaseRemoteConfig } from "../../../src/Utils/FirebaseRemoteConfig";
import {
  getCartItems,
  getDeviceType,
  getScreenName,
  showNewCartFlow,
} from '../../../src/Utils/helper';
import { goToCartHandler } from '../../../src/Utils/productAction';
import { fireViewedScreenEvent } from '../../../src/Utils/useFirebase';
import AskNow from '../../../src/components/QnaPage/AskNowSection/AskNow';
import {
  checkApiIsDev,
  devBuildPathQuestion,
  productionBuildPathQuestion,
} from '../../../src/Constants/QuestionPage';
import {
  filterQuestionData,
  getMetaDescription,
  getQuestionData,
  getTagData,
  trimmedToLength,
} from '../../../src/Utils/questionUtils';
import RelatedArticlesNew from '../../../src/components/ArticlePage/RelatedArticlesNew/RelatedArticlesNew';
import Loader from '../../../src/components/Loader';
import { fireEvent } from '../../../src/Utils/fireEvent';

export async function getStaticPaths() {
  if (checkApiIsDev()) return devBuildPathQuestion;

  return productionBuildPathQuestion;
}

export async function getStaticProps(context) {
  return getQuestionData(context, 'server');
}

export default function QuestionsPageComponent(props) {
  const [questionPagePropsData, setQuestionPagePropsData] = useState(props);

  let { questionData, questionId, categoryData } = questionPagePropsData;
  const { data, error, mutate } = useSWR(
    `question_${questionId}`,
    () => {
      const questionData = articleDetailFetcher('post', questionId, true);
      questionData.data = filterQuestionData(questionData?.data);
      return questionData;
    },
    {
      fallbackData: questionData,
      revalidateOnMount: true,
    },
  );
  const content = data?.data;
  const postData = content?.post;
  const postContent = content?.post?.content;
  const web_url = postContent?.web_url;
  const tagData = getTagData(postData);
  const primaryCategory = tagData?.description || 'Parenting';
  const titleTrimmed = trimmedToLength(
    postContent?.message,
    44 - primaryCategory?.length,
  );

  const metaTitle = `${primaryCategory}: ${titleTrimmed} | MyloFamily`;
  const relatedTopics = content?.similarTopics?.items;
  const breadCrumbsData = postData?.content?.breadcrumbs;
  const metaDescription = getMetaDescription(content, primaryCategory);
  const canonical_url = `https://mylofamily.com${web_url}`;

  const [addedToCart, setAddedToCart] = useState(false);
  const [showCartSnackBar, setShowCartSnackBar] = useState(false);
  const [showInstallStrip, setShowInstallStrip] = useState(true);
  const installLink = googlePlayStoreLink;
  const cartItems = getCartItems();
  const snackBarTimeoutRef = useRef(null);
  const deviceType = useRef('');
  const openGraphData = {
    title: metaTitle,
    description: metaDescription,
    type: 'website',
    url: canonical_url,
    images: [
      {
        url: content?.banner,
        width: 800,
        height: 800,
      },
    ],
  };
  if (!content?.banner) {
    delete openGraphData['images'];
  }
  useEffect(() => {
    setAddedToCart(false);
    if (addedToCart && !showNewCartFlow()) {
      clearTimeout(snackBarTimeoutRef.current);
      setShowCartSnackBar(true);
      snackBarTimeoutRef.current = setTimeout(() => {
        setShowCartSnackBar(false);
      }, 3000);
    }
  }, [addedToCart]);

  const cartCtaHandler = () => {
    fireEvent({
      category: 'clicked_go_to_cart_in_snackbar',
      screen_name: getScreenName(),
      item_count: cartItems.length || 0,
      id: cartItems.pop(),
    });
    goToCartHandler();
  };

  const closeInstallStrip = () => {
    fireEvent({
      category: 'discard_strip',
      screen_name: getScreenName(),
      page_url: typeof window != 'undefined' ? window.location.href : 'NA',
      parent: 'Install App Nudge Strip Mobile',
    });
    setShowInstallStrip(false);
  };

  useEffect(() => {
    fireViewedScreenEvent(
      questionId,
      postData?.content?.message?.substring(0, 98),
    );
    deviceType.current = getDeviceType();
  }, []);

  const checkAndUpdateQuestionData = async () => {
    const context = {
      params: { questionId: props.id },
      locale: props.locale,
    };
    if (!props.questionData) {
      const data = await getQuestionData(context, 'client');
      setQuestionPagePropsData(data.props);
    }
  };
  useEffect(() => {
    checkAndUpdateQuestionData();
  }, [props.id]);

  useEffect(() => {
    if (props.questionData) {
      setQuestionPagePropsData(props);
    }
  }, [props]);
  if (!questionPagePropsData.questionData) {
    return <Loader></Loader>;
  }
  return (
    <>
      {content ? (
        <QuestionsHead
          content={postContent}
          title={metaTitle}
          questionData={content}
          tagName={primaryCategory}
          breadCrumbsData={breadCrumbsData}
          commentsData={content?.comments}
        />
      ) : null}

      {getSeoVisibility() ? (
        <NextSeo
          title={metaTitle}
          description={metaDescription}
          openGraph={openGraphData}
          canonical_url={canonical_url}
        />
      ) : null}
      <GlobalStyle />
      <NewHeader
        setAddedToCart={setAddedToCart}
        addedToCart={addedToCart}
        categoryData={categoryData}
        nostrip={true}
      />
      <HomeWrapper noPadding>
        {showInstallStrip ? (
          <InstallNudge
            installLink={installLink}
            closeInstallStrip={closeInstallStrip}
            appIsPreasent={false}
          />
        ) : null}

        <SnackBar className={showCartSnackBar ? 'show' : ''}>
          ADDED TO CART SUCCESSFULLY{' '}
          <span onClick={cartCtaHandler}>GO TO CART</span>
        </SnackBar>
        {breadCrumbsData?.length && (
          <Breadcrumbs breadCrumbs={breadCrumbsData} postData={postData} />
        )}
        <ArticleGridSection>
          <QuestionContainer>
            <QuestionWrapper
              data={content}
              primaryCategory={primaryCategory}
              //installLink={installAppLinks}
              // installAppLink={installLink}
              contentId={questionId}
              contentType={'question'}
              contentData={postData?.content?.tags}
              postData={postData}
            />
          </QuestionContainer>
          <StickySection showOrder={-1}>
            <AskNow
              installLink={installLink}
              description={tagData?.description}
              //setShowDesktopNotifPopup={setShowDesktopNotifPopup}
            />

            <RelatedQuestionNew
              installLink={installLink}
              similarElements={content?.similarElements}
              pageType={'question'}
              questionId={questionId}
            />
          </StickySection>

          <StickySection showOrder={1}>
            {tagData ? <PostedIn tagData={tagData} /> : null}

            <RelatedArticlesNew
              pageType={'question'}
              similarElements={content?.similarElements}
            />

            <RelatedTopics
              pageType={'question'}
              topics={relatedTopics}
              paddingBottom={'9rem'}
            />
          </StickySection>
        </ArticleGridSection>
        <ProductsMayLikeSection>
          <ArticleProductCard
            setAddedToCart={setAddedToCart}
            similarElements={content?.similarElements}
            rupeeSymbol={true}
          />
        </ProductsMayLikeSection>
      </HomeWrapper>

      <NewFooter installLink={installLink} />
    </>
  );
}
